module.exports = __webpack_public_path__ + "img/new.4d6474be.png";